<template>
  <div>
    <v-card class="ma-2 pa-4">
      <v-card-text>
        <v-row>
          <v-col cols="6"
            ><v-textarea v-model="check_text" outlined rows="30"></v-textarea>
          </v-col>
          <v-col cols="6">
            <div id="inter_appmedia"></div>
            {{disp}}
            <span style="color:red;">{{ error_message }}</span>

            <div>
              <div style="padding:10px;font-weight:bold; font-size:16px;">
                {{formattedDate }}
              </div>
              <v-slider
                v-model="slider"
                thumb-label
                max="200"
                min="-100"
                @change="checkAd"
              ></v-slider>
              <v-btn @click="sub"> -</v-btn>

              <v-btn @click="add">+</v-btn>
            </div>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    ああああ
    <table class="pa-1" style="width: 100%">
      <tr>
        <th width="120">開始時刻</th>
        <td class="pa-1" width="40%">
          <VueCtkDateTimePicker
            v-model="start_date"
            :minute-interval="1"
            :format="'YYYY-MM-DD HH:mm'"
            :overlay="true"
            label="start"
            :no-label="true"
          ></VueCtkDateTimePicker>
        </td>
        <th width="120">終了時刻</th>
        <td class="pa-1" width="40%">
          <VueCtkDateTimePicker
            v-model="end_date"
            :minute-interval="1"
            :format="'YYYY-MM-DD HH:mm'"
            :overlay="true"
            label="end"
            :no-label="true"
          ></VueCtkDateTimePicker>
        </td>

        <td width="180" style="color: green">
          {{ timeSub(start_date, end_date) }}
        </td>
      </tr>
    </table>
  </div>
</template>
<script>
import VueCtkDateTimePicker from "vue-ctk-date-time-picker";
import "vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css";

export default {
  components: {
    VueCtkDateTimePicker: VueCtkDateTimePicker,
  },

  data() {
    return {
      check_text: "",
      error_message: "",

      check_data: [],

      slider: 100,

      search: "",
      start_date: "",
      end_date: "",

      //表示テスト
      formattedDate: "",
      target_time: "",
      disp: "",
    };
  },

  watch: {
    check_text() {
      var tmp;
      try {
        tmp = JSON.parse("[" + this.check_text + "]");
      } catch (e) {
        this.error_message = "形式が間違っています。";
        console.log(e);
        return;
      }
      this.error_message = "";
      if (!Array.isArray(tmp)) {
        this.error_message = "形式が間違っています(2)。";
        return;
      }

      this.check_data = tmp;

      // tmp.forEach(function(item){
      // var startDate = item.start;
      // // var endDate = item.end;
      // // var nowDate = new Date();
      // console.log(startDate);

      // });
    },
  },

  beforeCreate: function() {},

  computed: {},

  created: function() {},

  methods: {
    //広告表示テスト
    checkAd: function() {
      this.checkTime();
      var self = this
      self.disp = "";
      document.getElementById('inter_appmedia').innerHTML= '';
      this.check_data.forEach(function(item) {
        
        var startDate = item.start;
        var endDate = item.end;
        var nowDate = self.target_time;

        console.log(startDate,endDate,nowDate);


        if (startDate) {
          startDate = new Date(startDate);
        } else {
          startDate = nowDate;
        }
        if (endDate) {
          endDate = new Date(endDate);
        }
        if (startDate <= nowDate) {
          if (!endDate || nowDate <= endDate) {
            self.disp = "OK";

              document.getElementById('inter_appmedia').innerHTML='<div class="inste_popup" id="js-popup"><div class="popup-inner"> <div class="close-btn" id="js-close-btn"><i class="fa fa-times"></i></div><a target="_blank" id="c_inste_ad" href="'+item.link+'"><img src="'+item.img+'" width=100% height=auto> <div class="title_wrapper_inste">'+item.title+'</div> </a></div>  <div class="black-background" id="js-black-bg"></div></div>' ;
          }
        }

        console.log(startDate ,endDate );
      });
    },
    //時間の切り替え
    checkTime: function() {

      var val = this.slider
      var date = new Date();
      // console.log(date.getFullYear() + "/" +  (date.getMonth() + 1)   + "/" + date.getDate() + " 00:00");

      date = new Date(
        date.getFullYear() +
          "/" +
          (date.getMonth() + 1) +
          "/" +
          date.getDate() +
          " 00:00"
      );
      //30分後
      date.setMinutes(date.getMinutes() + 30 * val);

      this.target_time = date;

      // date.setMinutes(date.getMinutes() + 10 * val);
      this.formattedDate =
        date.getFullYear() +
        "/" +
        ("0" + (date.getMonth() + 1)).slice(-2) +
        "/" +
        ("0" + date.getDate()).slice(-2) +
        " " +
        ("0" + date.getHours()).slice(-2) +
        ":" +
        ("0" + date.getMinutes()).slice(-2);

      // return formattedDate;
    },

    add(){
      this.slider += 1;
      this.checkAd();
    },
    sub(){
      this.slider -= 1;
      this.checkAd();
    },
    //時間差分
    timeSub: function(start, end) {
      if (start == "" || end == "") {
        return "";
      }

      var date1 = new Date(start);
      var date2 = new Date(end);
      var diff = date2 - date1;
      console.log("diff", diff);
      var day = Math.abs(diff) / (24 * 60 * 60 * 1000);
      var hour =
        (diff - Math.floor(day) * (24 * 60 * 60 * 1000)) / (60 * 60 * 1000);

      // ミリ秒 （そのまま）
      console.log("day", Math.floor(day));
      console.log("hour", Math.floor(hour));

      return "約" + Math.floor(day) + "日" + Math.floor(hour) + "時間";
    },
  },

  // //  //描写前の処理（一覧表示）
  // async asyncData({ app }) {
  //   var response = [];
  //   const baseUrl =
  //     "https://article.matomeroyal.com/wp-json/appmedia/tool/review_category_list";
  //   response = await app.$axios.$get(baseUrl);
  //   return {
  //     category: response
  //   };
  // }
};
</script>
<style>
.v-card__title {
  padding: 6px 18px !important;
}
.col {
  padding: 4px 18px !important;
}
.v-card__text {
  padding: 0 0 0 10px;
}

.v-input--radio-group__input {
  flex-wrap: wrap;
}

/* .preview{
  border: 1px solid red !important;
} */

/* .preview img {
  width: auto;
  max-height: 400px;
} */

.namelist .v-input--radio-group__input {
  flex-direction: row !important;
}
.namelist .v-radio {
  padding: 6px 16px 6px 0;
  margin: 4px 10px 4px 0 !important;
  border-right: 1px solid #ddd;
}

.namelist .v-item--active label {
  color: #1976d2;
}

.tablist .v-tab--active {
  color: #1976d2;
  font-weight: bold;
}

.v-text-field input {
  font-size: 16px;
}
.v-textarea textarea {
  line-height: 1.6;
  font-size: 15px;
}

.new_icon {
  border: 1px solid red;
  color: red;
  margin-right: 8px;
  padding: 1px 4px;
}

.v-application .addSetting {
  padding: 0 16px;
  margin: 9px;
  height: 32px !important;
  border: none;
  background: #fff;
  color: #6d6d6d;
  font-weight: bold;
  font-size: 14px;
  border: 1px dashed #aaa;
}
main .v-application .addSetting::before {
  content: "＋";
  font-size: 30px;
}

.deletebtn {
  color: red !important;
  font-weight: bold;
  margin-left: 10px;
  border: none;
  min-width: 40px !important;
}

.preview_csv {
  border-collapse: collapse;
}

.preview_csv td {
  font-size: 12px;
  line-height: 1.4;
  color: #333;
  border: 1px solid #ccc;
  padding: 4px;
  text-align: center;
}

.preview_csv tr:nth-child(odd) td {
  background: #fff3ef;
}
</style>
